import MUIDialogContentText from '@mui/material/DialogContentText'

export const DialogContentText = MUIDialogContentText
